// extracted by mini-css-extract-plugin
module.exports = {"app":"style_app__187sN","overlay":"style_overlay__1EhSz","dashboard":"style_dashboard__TGAY7"};